<template>
  <div
    id="app"
    :class="{ 'has-sticky-promo': hasStickyPromo }">
    <router-view />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import componentWithDynamicModule from 'assets/extends/componentWithDynamicModule';
import ModuleStore from '@modules/Auth';
import { catalogRouteNames } from '@/router/constants';

import authTypes from 'assets/utils/constants/authTypes';
import vars from 'assets/utils/vars';

function needAuth() {
  return vars.settings.auth_type === authTypes.NO;
}

export default {
  name: 'Main',

  mixins: !needAuth() ? [componentWithDynamicModule('Auth', ModuleStore, false)] : [],

  computed: {
    ...mapState(['isAuthorized', 'mainSettings', 'windowWidth']),

    hasStickyPromo() {
      if (this.$route.name !== catalogRouteNames.MAIN_CATALOG_LIST) return false;

      const width = this.windowWidth || document.documentElement.clientWidth;
      const appearance = this.mainSettings.appearance || {};
      return width > 900 && (appearance.promo_top?.sticky === true || appearance.promo_bottom?.sticky === true);
    },
  },

  watch: {
    // установка meta заголовков
    '$route': {
      immediate: true,
      handler(to) {
        /**
         * возможно потом понадобится переделать с просто meta маршрута на
         * выборку первого элемента из mathed, имеющего meta
         */
        if (to.meta && to.meta.title) {
          this.SET_META(to.meta);
        }
      },
    },
  },

  created() {
    if (!this.isAuthorized) {
      this.SET_AUTHORIZED_STATUS();
    }
  },

  mounted() {
    this.SET_WINDOW_WIDTH(document.documentElement.clientWidth);
    window.addEventListener('resize', () => {
      this.SET_WINDOW_WIDTH(document.documentElement.clientWidth);
    });
  },

  methods: {
    ...mapMutations([
      'SET_WINDOW_WIDTH',
      'SET_AUTHORIZED_STATUS',
    ]),
  },
};
</script>

<style lang="stylus">
html {
  box-sizing: border-box;
  font-family 'IBM Plex Sans', sans-serif
  color $colors.grey.base
  overflow-y scroll
}
*, *:before, *:after {
  box-sizing: inherit;
}

#app {
  overflow-x: hidden;
  &.has-sticky-promo {
    overflow-x: clip;
  }
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 0.7rem;
  height: 0.7rem;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: #aeb5bf;
  border-radius: 0.4rem;
}
::-webkit-scrollbar-corner {
  background: transparent;
}

</style>
